import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[selectDropdownRequiredValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: SelectDropdownRequiredValidatorDirective,
        multi: true
    }]
})

export class SelectDropdownRequiredValidatorDirective implements Validator {
    @Input() selectDropdownRequiredValidator: string;
    validate(c: AbstractControl): { [key: string]: any } {
        const val: string = c.value;
        return (val === this.selectDropdownRequiredValidator) ? { 'defaultSelected': true } : null;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/directives/select-dropdown-required-validator.ts